// @flow

import * as React from 'react';
import { useDropzone } from 'react-dropzone';
import styled from '@emotion/styled';
import Icon from 'app/components/commons/Icon';
import Button from 'app/components/commons/Button';
import Spinner from 'app/components/commons/Spinner';

type Props = {
  autoBorderRadius?: boolean,
  buttonSize?: 'small' | 'medium' | 'large',
  className?: string,
  disabled?: boolean,
  maxSize: number,
  multiple?: boolean,
  onDrop: (acceptedFiles: Array<Object>, rejectedFiles: Array<Object>) => void,
  uploading?: boolean
};

const ButtonLabel = styled.span(({ theme }) => ({
  marginRight: theme.spacing.xsmall
}));

const StyledIcon = styled(Icon)({
  fontSize: '1.2em'
});

function CSVUploadButton({
  autoBorderRadius,
  buttonSize,
  className,
  disabled,
  maxSize,
  multiple,
  onDrop,
  uploading
}: Props) {
  const handleDrop = React.useCallback(onDrop, []);
  const { getRootProps, getInputProps } = useDropzone({
    accept: '.csv',
    maxSize,
    multiple,
    onDrop: handleDrop
  });

  return (
    <div {...getRootProps({ className })}>
      <input {...getInputProps()} />
      <Button
        block
        autoBorderRadius={autoBorderRadius}
        kind="success"
        size={buttonSize}
        disabled={disabled}
      >
        <div className="buttonInner">
          {uploading && <Spinner inlineLeft />}
          <ButtonLabel>{uploading ? 'Uploading CSV...' : 'Upload CSV'}</ButtonLabel>
          {!uploading && <StyledIcon type="icon-cloud-upload" />}
        </div>
      </Button>
    </div>
  );
}

CSVUploadButton.defaultProps = {
  autoBorderRadius: false,
  buttonSize: 'medium',
  className: undefined,
  disabled: false,
  multiple: false,
  uploading: false
};

export default CSVUploadButton;
